import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { isNull } from 'lodash'
import { CircularProgressbar } from 'react-circular-progressbar'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { toggleMediumWidget } from '../DashboardSlice'
import { MediumWidgetsName } from '../types'
import { WidgetWrapper } from '../widgetsComponents'

export const TargetAccuracy: FC = () => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()
  const dispatch = useAppDispatch()

  const { widgetsData, mediumWidgetsList } = useAppSelector(({ dashboard }) => dashboard)

  const takeProfit = widgetsData?.targetAccuracy?.takeProfit
  const stopLoss = widgetsData?.targetAccuracy?.stopLoss

  const handleCheck = () => {
    dispatch(toggleMediumWidget(MediumWidgetsName.targetAccuracy))
  }

  return (
    <WidgetWrapper
      label={t('targetAccuracy', 'Target accuracy')}
      handleCheck={handleCheck}
      isChecked={mediumWidgetsList[MediumWidgetsName.targetAccuracy]}
      explanation={t(
        'assessesTheEffectivenessOfTraderTakeProfitAndStopLossStrategy',
        "Assesses the effectiveness of a trader's take profit and stop loss strategy",
      )}
    >
      <Box display="flex" flexDirection="column" height="100%" gap={spacing(3)} width="100%">
        <Box display="flex" marginTop={spacing(2)}>
          <Box width={spacing(8)}>
            <Typography fontWeight="bold" color={palette.grey[700]} fontSize={12}>
              {t('takeProfit', 'Take profit')}
            </Typography>
            <Typography variant="h3">
              {isNaN(takeProfit) || isNull(takeProfit) ? '-' : `${takeProfit}%`}
            </Typography>
          </Box>
          <Box flex={1} display="flex" justifyContent="center">
            <Box width={spacing(7)} height={spacing(7)}>
              <CircularProgressbar
                value={takeProfit}
                styles={{
                  path: {
                    stroke: palette.green[400],
                    strokeLinecap: 'butt',
                    transition: 'stroke-dashoffset 0.5s ease 0s',
                    transformOrigin: 'center center',
                  },
                  trail: {
                    stroke: palette.grey[500],
                    strokeLinecap: 'butt',
                    transformOrigin: 'center center',
                  },
                  background: {
                    fill: palette.cyan[500],
                  },
                }}
                strokeWidth={16}
              />
            </Box>
          </Box>
        </Box>
        <Box display="flex">
          <Box width={spacing(8)}>
            <Typography fontWeight="bold" color={palette.grey[700]} fontSize={12}>
              {t('stopLoss', 'Stop loss')}
            </Typography>
            <Typography variant="h3">
              {isNaN(stopLoss) || isNull(stopLoss) ? '-' : `${stopLoss}%`}
            </Typography>
          </Box>
          <Box flex={1} display="flex" justifyContent="center">
            <Box width={spacing(7)} height={spacing(7)}>
              <CircularProgressbar
                value={stopLoss}
                styles={{
                  path: {
                    stroke: palette.red[400],
                    strokeLinecap: 'butt',
                    transition: 'stroke-dashoffset 0.5s ease 0s',
                    transformOrigin: 'center center',
                  },
                  trail: {
                    stroke: palette.grey[500],
                    strokeLinecap: 'butt',
                    transformOrigin: 'center center',
                  },
                  background: {
                    fill: palette.cyan[500],
                  },
                }}
                strokeWidth={16}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </WidgetWrapper>
  )
}
